export enum JourneyNodeType {
  // No-Op node type. Meant only for testing.
  NoOp = "no-op",

  EntryEvent = "entry-event",
  EntryCohort = "entry-cohort",
  EntryAudienceExperiment = "entry-audience-experiment",
  WaitUntilEvent = "wait-until-event",
  TimeDelay = "time-delay",
  Segments = "segments",
  Splits = "splits",
  Sync = "sync",
  // Realtime only. Calls a Function and holds the user until its response comes back.
  Function = "function",
  EventEmission = "event-emission",
  Context = "context",
  CouponAssignment = "coupon-assignment",
  Message = "message",
  Decision = "decision",

  // Branch nodes
  SegmentBranch = "segment-branch",
  WaitUntilEventBranch = "wait-until-event-branch",
  SplitBranch = "split-branch",
  EntryAudienceExperimentBranch = "entry-audience-experiment-branch",
}

export enum JourneyNodeSyncMode {
  Cohort = "cohort",
  Trigger = "trigger",
  Message = "message",
  // An HTTP Lookup sync owned by a Set variable tile. Its model is the members
  // held at the tile, keyed by journey entry.
  Lookup = "lookup",
}

export const SYNC_TIMEOUT_ACTIONS = ["continue", "exit"] as const;
export type JourneySyncTimeoutAction = (typeof SYNC_TIMEOUT_ACTIONS)[number];
export const DEFAULT_SYNC_TIMEOUT_ACTION: JourneySyncTimeoutAction = "continue";

export const MISSING_WAREHOUSE_DATA_BEHAVIORS = [
  "evaluate_as_false",
  "hold",
] as const;
export type MissingWarehouseDataBehavior =
  (typeof MISSING_WAREHOUSE_DATA_BEHAVIORS)[number];
export const DEFAULT_MISSING_WAREHOUSE_DATA_BEHAVIOR: MissingWarehouseDataBehavior =
  "evaluate_as_false";
